import React from 'react';
import ULForms from '../Additional/ULForms';
import layouts from './panelShopLayouts.json';

export default function PanelShopForms({ projectId }) {
  return <ULForms projectId={projectId} layouts={layouts} category="Panel Shop" />;
}
